<template>
  <div class="layer packageComponentList">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle toCapitalize">패키지 컴포넌트</h2>
      <div v-if="list && list.length" class="tagList">
        <input type="text" class="input mb15" placeholder="component code" v-model="search" />
        <div class="tagBox mb15">
          <div class="listLabel">활성화 컴포넌트</div>
          <div v-if="checkedList && checkedList.length > 0" class="tagListItems">
            <div
              v-for="(item, index) in checkedList"
              :key="index"
              class="tagItem delItem tagDark clickable"
              @click="item.checked = false">
              <span>{{ item.code }}</span>
            </div>
          </div>
          <div v-else class="noData">컴포넌트를 선택해주세요.</div>
        </div>
        <div class="tagBox mb5">
          <div class="listLabel">미사용 컴포넌트</div>
          <div v-if="unCheckedList && unCheckedList.length > 0" class="tagListItems">
            <div
              v-for="(item, index) in unCheckedList"
              :key="index"
              class="tagItem clickable"
              @click="item.checked = true">
              <span>{{ item.code }}</span>
            </div>
          </div>
          <div v-else class="noData">등록된 컴포넌트가 없습니다.</div>
        </div>
      </div>
      <div v-else>등록된 컴포넌트가 없습니다.</div>
      <div class="btns">
        <button type="button" class="btn btnFull btnPrimary toCapitalize" @click="apply">{{locale.apply}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'PackageComponentList',
  props: [
    'locale',
    'componentList'
  ],
  components: {
  },
  computed: {
    getPackageResultData () {
      return this.$store.getters['package/getPackageResultData']
    },
    checkedList () {
      const word = regExp.replaceAllEmpty(this.search.toLowerCase())
      const list = this.list.filter(x => x.checked)
      return list.filter(x => word ? x.code.toLowerCase().includes(word) : x.code)
    },
    unCheckedList () {
      const word = regExp.replaceAllEmpty(this.search.toLowerCase())
      const list = this.list.filter(x => !x.checked)
      return list.filter(x => word ? x.code.toLowerCase().includes(word) : x.code)
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      list: [],
      search: ''
    }
  },
  methods: {
    async init () {
      const res = await this.$store.dispatch('package/getPackageComponentList')
      const components = this.componentList || []
      if (res && res.status === 200) {
        const list = res && res.message && res.message.components
        if (list && list.length > 0) {
          this.list = list.map(x => {
            return {
              ...x,
              checked: components.includes(x.code)
            }
          })
        }
      } else {
        const status = (res && res.data && res.data.status) || 500
        const message = this.getPackageResultData(status)
        alert(message)
      }
    },
    apply () {
      if (window.confirm(this.locale.confirm_apply)) {
        this.$emit('apply', this.list.filter(x => x.checked))
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    }
  }
}
</script>
